import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
  ChallengeSuccess,
  ChallengeSuccessService
} from '@com-delta-idp/mnx-oauth';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LOGIN_MODAL_CHALLENGE_URL } from '../../util/login-modal.constant';
import { AnalyticsData } from '../login-authentication-screen/models/login-credentials.interface';
import { ResetPasswordContent } from './model/reset-password.interface';
@Component({
  selector: 'idp-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm!: UntypedFormGroup;
  private _content = {} as ResetPasswordContent;
  @Input() machCore = false;
  @Input() set content(value: ResetPasswordContent) {
    this._content = value;
    if (this.resetPasswordForm && value?.formGroup) {
      this.resetPasswordForm = value.formGroup as UntypedFormGroup;
    }
  }

  get content(): ResetPasswordContent {
    return this._content;
  }

  @Output() formSubmitEvent: EventEmitter<ElementRef> =
    new EventEmitter<ElementRef>();

  @Output() focusInvalidField: EventEmitter<string> =
    new EventEmitter<string>();

  @Output() triggerClose = new EventEmitter();
  @Output() fieldFocusOut: EventEmitter<string> = new EventEmitter<string>();
  @Output() inputChange: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  pageLoadStartTime: number;
  viewName = 'resetPassword';
  constructor(private challengeSuccessService: ChallengeSuccessService) {
    this.pageLoadStartTime = performance.now();
  }

  private _unsubscribe$ = new Subject();

  ngOnInit() {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Reset Password',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
    this.resetPasswordForm = this._content.formGroup as UntypedFormGroup;
    this.checkForChallengeScreen();
  }

  public get showErrorMessageUserId() {
    const control: UntypedFormControl = this.resetPasswordForm?.get(
      'userId'
    ) as UntypedFormControl;
    return (
      control &&
      this.content.formAttributes.userIdControlTouched &&
      control.invalid
    );
  }

  public get showErrorMessageFirstName() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.resetPasswordForm.get('firstName')
    );
    return (
      control &&
      this.content.formAttributes.firstNameControlTouched &&
      control.invalid
    );
  }

  public get showErrorMessageLastName() {
    const control: UntypedFormControl = <UntypedFormControl>(
      this.resetPasswordForm.get('lastName')
    );
    return (
      control &&
      this.content.formAttributes.lastNameControlTouched &&
      control.invalid
    );
  }

  onFocusFirstInvalidField() {
    this.focusInvalidField.emit();
  }

  onSubmit() {
    this.redirectTrackingClick.emit({ action: this.viewName });
    this.formSubmitEvent.emit();
  }

  onFocussedOut(fieldName: string) {
    this.fieldFocusOut.emit(fieldName);
  }

  onChange(controlName: string) {
    this.inputChange.emit(controlName);
  }

  closePopup() {
    this.closeOverlayMessage.emit(false);
  }

  displayNextView(viewName: string) {
    this.redirectTrackingClick.emit({ action: 'forgotlogin' });
    this.nextDisplayView.emit(viewName);
  }

  checkForChallengeScreen(): void {
    this.challengeSuccessService._callBackAfterSuccessChallenge$
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((data: ChallengeSuccess) => {
        if (
          data?.callBack &&
          (data?.url?.includes(LOGIN_MODAL_CHALLENGE_URL.FORGOT_LOGIN) ||
            data?.url?.includes(LOGIN_MODAL_CHALLENGE_URL.LOGIN))
        ) {
          this.onSubmit();
          this.challengeSuccessService.resetValues();
        }
      });
  }
}
